import Icon from "@/components/icons";
import { IconTypes } from "@/components/icons/types";
import { cn } from "@/lib/utils";

type IconDescriptionProps = {
  iconType: IconTypes;
  title: string | React.ReactNode;
  subtitle: string;
  variant?: "horizontal" | "vertical";
  svgProps?: React.SVGProps<SVGSVGElement>;
  textColor?: string;
  subtitleClassname?: string;
};

export default function IconDescription({
  iconType,
  title,
  subtitle,
  variant = "horizontal",
  svgProps = { width: "40", height: "40" },
  textColor = "text-putty-200",
  subtitleClassname,
}: IconDescriptionProps) {
  const finalSubtitleClassname = cn(
    "text-sm block mt-1 text-putty-200",
    subtitleClassname,
  );
  if (variant === "vertical") {
    return (
      <div className={`${textColor} flex flex-col items-center text-center`}>
        <Icon type={iconType} svgProps={svgProps} />
        <div className="mt-3">
          <span className="mt-0 font-bold text-lg block">{title}</span>
          <span className={finalSubtitleClassname}>{subtitle}</span>
        </div>
      </div>
    );
  }

  return (
    <div className={`${textColor} flex flex-row`}>
      <Icon type={iconType} svgProps={svgProps} />
      <div className="ml-5">
        <span className="mt-0 font-bold text-lg">{title}</span>
        <br />
        <span className={finalSubtitleClassname}>{subtitle}</span>
      </div>
    </div>
  );
}
